// components.
import { FieldsMX } from './FieldsMX/FieldsMX';
import { ApproveFormBase } from '../shared/ApproveFormBase';
import { defaultValuesMX } from '../utils';
import { ApproveFormMX as ApproveFormMXType } from '@domains/documents-review/interfaces/interfaces';
import { serializeAccessoryAreas } from '@domains/documents-review/utils/accessoryAreas';
import { CountryCode } from '@domains/country';

export const ApproveFormMX = () => {
  const formatTaskResult = (data: any): ApproveFormMXType => ({
    comment: data.comment,
    complex: data.complex,
    admin_price: Number(data.adminPrice ?? 0),
    property_type: data.propertyType,
    median_zone: data.medianZone,
    zip_code: data.zipCode,
    property_document_type: data.documentType,
    committee_price_area: Number(data.committeePriceArea),
    committee_land_area: Number(data.committeeLandArea),
    committee_expansion_area: Number(data.committeeExpansionArea),
    rooms: Number(data.rooms),
    baths: Number(data.baths),
    half_bathroom: Number(data.halfBaths),
    floor: Number(data.floor),
    elevator: Number(data.elevator),
    has_garage_doc: data.hasGarageDoc,
    garage: Number(data.garage ?? 0),
    years_old: Number(data.yearsOld),
    parking_with_double_key_or_deed: Boolean(data.parkingWithDoubleKeyOrDeed),
    accessory_areas: serializeAccessoryAreas(data.accessoryAreas, CountryCode.MX),
  });

  return (
    <ApproveFormBase
      fieldsComponent={<FieldsMX />}
      defaultValues={defaultValuesMX}
      formatTaskResult={formatTaskResult}
    />
  );
};
